import { baseUrl } from "../../common/config";
import { http } from "../../common/helpers";
import { ApiResponse } from "../../models/api/api-response";
import { CollectibleType } from "../../models/collectible";

interface Collectible {
  collectableType: CollectibleType;
  title: string;
  assignedByFullName: string;
  assignedDate: string;
  contentLink: string;
  collectableId: string;
}

interface Data {
  totalRecords: number;
  data: Collectible[];
}

export const getParticipantCollectibles = async ({ ...params }) => {
  const { data } = await http.get<ApiResponse<Data>>(
    `${baseUrl}/api/assessments/collectable/participant`,
    {
      params,
    }
  );
  return data.data;
};

export const getCollectiblesTypes = async () => {
  const { data } = await http.get(
    `${baseUrl}/api/assessments/collectable/types`
  );
  return data.data;
};
